import { combineReducers } from "redux";

import freeconsultation from "../features/admin/freeconsultations/freeconsultation/Slice";

import common from "../features/admin/common/Slice";

const freeconsultations = combineReducers({
    freeconsultation,
    common
});

export default freeconsultations;